'use client'

import {authApi} from "@/store/api/v1/auth";
import {ForgotPasswordForm} from "@/components/Auth/ForgotPasswordModal/ForgotPasswordModal.styled";

const ForgotPasswordFormAction = ({children}) => {
    return (
        <ForgotPasswordForm api={authApi} endpoint={'forgotPassword'}>
            {children}
        </ForgotPasswordForm>
    );
};

export default ForgotPasswordFormAction;